import { IMountedCameraOption } from "./types";

export const BUFFER_TICKS = 256;

export const MOUNTED_CAMERA_OPTIONS: IMountedCameraOption[] = [
  { value: "none", label: "None", description: "No camera effect" },
  { value: "as_cam_face", label: "Face", description: "Portrait angle" },
  { value: "as_cam_profile", label: "Profile", description: "Side view" },
  { value: "as_cam_gun", label: "Gun", description: "Weapon close-up" },
  { value: "as_cam_hip", label: "Hip", description: "Hip-level shot" },
  { value: "as_cam_tps", label: "Third Person", description: "Behind player" },
  { value: "as_cam_heli", label: "Aerial", description: "Helicopter view" },
];

// Map display weapon names to icon file names
export const WEAPON_ICON_MAP: Record<string, string> = {
  "ak-47": "ak47",
  m4a4: "m4a1",
  "m4a1-s": "m4a1_silencer",
  m4a1: "m4a1",
  awp: "awp",
  "desert eagle": "deagle",
  "usp-s": "usp_silencer",
  "glock-18": "glock",
  p2000: "p2000",
  p250: "p250",
  "five-seven": "fiveseven",
  "tec-9": "tec9",
  "cz75-auto": "cz75a",
  "dual berettas": "elite",
  "r8 revolver": "revolver",
  "galil ar": "galilar",
  famas: "famas",
  "sg 553": "sg556",
  aug: "aug",
  "ssg 08": "ssg08",
  "scar-20": "scar20",
  g3sg1: "g3sg1",
  "mac-10": "mac10",
  mp9: "mp9",
  mp7: "mp7",
  "mp5-sd": "mp5sd",
  "ump-45": "ump45",
  p90: "p90",
  "pp-bizon": "bizon",
  nova: "nova",
  xm1014: "xm1014",
  "mag-7": "mag7",
  "sawed-off": "sawedoff",
  m249: "m249",
  negev: "negev",
  "zeus x27": "taser",
  knife: "knife",
  bayonet: "bayonet",
  karambit: "knife_karambit",
  "m9 bayonet": "knife_m9_bayonet",
  "butterfly knife": "knife_butterfly",
  "flip knife": "knife_flip",
  "gut knife": "knife_gut",
  "falchion knife": "knife_falchion",
  "bowie knife": "knife_bowie",
  "shadow daggers": "knife_push",
  "huntsman knife": "knife_tactical",
  "navaja knife": "knife_gypsy_jackknife",
  "stiletto knife": "knife_stiletto",
  "talon knife": "knife_widowmaker",
  "ursus knife": "knife_ursus",
  "paracord knife": "knife_cord",
  "survival knife": "knife_canis",
  "nomad knife": "knife_outdoor",
  "skeleton knife": "knife_skeleton",
  "classic knife": "knife_css",
  "kukri knife": "knife_kukri",
  "he grenade": "hegrenade",
  flashbang: "flashbang",
  "smoke grenade": "smokegrenade",
  "incendiary grenade": "incgrenade",
  molotov: "molotov",
  "decoy grenade": "decoy",
  c4: "c4",
  world: "icon_suicide",
  inferno: "inferno",
};
